import React, { useEffect, useRef, useState } from 'react';
import { soporteApi } from '../services/api';

export default function SupportNotifications({ usuario, onOpen }) {
  const [data, setData] = useState({ notifications: [], unread: 0 });
  const [opened, setOpened] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    let active = true;
    const refresh = async () => {
      if (document.hidden) return;
      try {
        const result = await soporteApi('/notifications');
        if (active) { setData(result); setError(''); }
      } catch (e) { if (active) setError('No se pudieron actualizar las alertas.'); }
    };
    refresh();
    const interval = setInterval(refresh, 15000);
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => { active = false; clearInterval(interval); window.removeEventListener('focus', refresh); document.removeEventListener('visibilitychange', refresh); };
  }, [usuario]);
  useEffect(() => {
    const close = e => { if (e.key === 'Escape' || (e.type === 'mousedown' && !ref.current?.contains(e.target))) setOpened(false); };
    document.addEventListener('mousedown', close);
    document.addEventListener('keydown', close);
    return () => { document.removeEventListener('mousedown', close); document.removeEventListener('keydown', close); };
  }, []);
  const open = async notification => {
    setBusy(true);
    try {
      await soporteApi(`/notifications/${notification.id}/read`, { method: 'PATCH' });
      setData(prev => ({ unread: Math.max(0, prev.unread - (notification.read_at ? 0 : 1)), notifications: prev.notifications.map(n => n.id === notification.id ? { ...n, read_at: n.read_at || new Date().toISOString() } : n) }));
      setOpened(false);
      onOpen(notification.ticket_id);
    } catch (e) { setError('No se pudo abrir la alerta. Intentá nuevamente.'); }
    finally { setBusy(false); }
  };
  return <div className="relative" ref={ref}>
    <button type="button" aria-label={`Alertas de soporte: ${data.unread} sin leer`} aria-expanded={opened} onClick={() => setOpened(value => !value)} className="relative rounded-full p-2 text-slate-700 dark:text-slate-200 hover:bg-slate-200 dark:hover:bg-slate-700">
      <span className="material-symbols-outlined" aria-hidden="true">notifications</span>
      {data.unread > 0 && <span className="absolute -right-1 -top-1 rounded-full bg-red-600 px-1.5 text-xs font-bold text-white">{data.unread > 99 ? '99+' : data.unread}</span>}
    </button>
    {opened && <section aria-label="Alertas de soporte" className="absolute right-0 z-50 mt-3 w-[min(22rem,calc(100vw-2rem))] rounded-2xl border border-slate-200 bg-white p-4 shadow-xl dark:border-slate-700 dark:bg-slate-900">
      <h2 className="mb-3 font-bold text-slate-900 dark:text-white">Alertas de soporte</h2>
      {error && <p role="alert" className="mb-2 text-sm text-red-600 dark:text-red-300">{error}</p>}
      {!data.notifications.length && !error && <p className="text-sm text-slate-500">No tenés alertas.</p>}
      <ul className="max-h-80 space-y-2 overflow-y-auto">{data.notifications.map(n => <li key={n.id}><button type="button" disabled={busy} onClick={() => open(n)} className={`w-full rounded-xl p-3 text-left text-sm text-slate-800 dark:text-slate-100 ${n.read_at ? 'bg-slate-50 dark:bg-slate-800' : 'bg-emerald-50 dark:bg-emerald-950 font-semibold'}`}>
        <span className="block">{n.message}</span><span className="mt-1 block text-xs font-normal text-slate-500 dark:text-slate-400">{new Date(n.created_at).toLocaleString('es-AR')}{!n.read_at && ' · Sin leer'}</span>
      </button></li>)}</ul>
    </section>}
  </div>;
}
